function EanCodeExample(el) {
    this.init(el);
}

$.extend(EanCodeExample.prototype,{
    $el:null,
    type:'ean',
    pid:'',
    prev:{abort:function(){}},
    init:function(el) {
        this.$el = $(el);
        this.pid = this.$el.attr('data-pid');
        this.type = this.$el.attr("data-type") || "ean";
        this.renderType();
        this.$el.find("input").on("change keyup",this.renderType.bind(this));
    },
    renderType:function() {
        console.log("render type",this.type);
        var e = false;
        switch(this.type){
            case "ean":
               e = this.renderEan();
                break;
            case "qr":
                e =this.renderQR();
                break;
        }
        if(e) {
            this.$el.find(".place-example").html("").append(e);
        }
        this.checkAvail();
    },
    renderEan:function() {
        var e = $('<img/>');
        try {
            JsBarcode(e[0], this.$el.find("input").val(), {
                format: 'CODE128',
                height: 60,
            });
        } catch(e) {
            return false;
        }
        return e;
    },
    renderQR:function() {
        var e = $('<div></div>');
        new QRCode(e[0],{
            text:this.$el.find("input").val(),
            width: 80,
            height: 80,
            colorDark : "#000000",
            colorLight : "#ffffff",
            correctLevel : QRCode.CorrectLevel.H
        });
        return e;
    },
    checkAvail:function() {
        this.prev.abort();
        this.prev = $.getJSON("/qrscanner/check",{
            product_id:this.pid,
            val:this.$el.find("input").val()
        },function(resp) {
            console.log(resp);
            if(resp.avail) {
                this.$el.find('.has-error').removeClass('has-error');
                this.$el.find('.error-message').remove();
            }else{
                this.$el.find('.fg-line').addClass('has-error');
                this.$el.find('.error-message').remove();
                this.$el.append($('<div class="error-message">'+resp.message+'</div>').css("color","#FF0000"));
            }
        }.bind(this));
    }
});


function UpdateEanCodeExample() {
    $(".ean-code-example").each(function(){
        if($(this).hasClass("enabled")) {
            return;
        }
        $(this).addClass("enabled");
        new EanCodeExample(this);
    });
}

$(function(){
    UpdateEanCodeExample();
});